import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { VoiceClient } from 'modules/ai_voice/components/VoiceClient'

import './index.css'

export function FactorialVoiceAgent() {
  // TODO: implement showing the voice agent with a feature flag
  const [searchParams] = useSearchParams()
  const intentParam = searchParams.get('voice-agent')
  const [intent, setIntent] = useState<string | null>(null)

  useEffect(() => {
    if (intentParam) setIntent(intentParam)
  }, [intentParam])

  if (!intent) return null

  return (
    <div className="factorial-voice-agent-popup">
      <VoiceClient intent={intent} />
    </div>
  )
}
